<template>
  <div class="wzbmid-wrapper">
    <div class="wzbmid">
      <div class="mid-title">
        支部负责人
      </div>


      <div class="box box_f1" :style="{paddingTop:height*0.0294+'px'}" style="justify-content: space-between">
        <div class="box_v mid-people box_f1" v-for="(item,index) in leader" :key="index">
          <div class="mid-pic" :style="{height: height*0.098+'px',width:height*0.098+'px',marginBottom:height*0.025+'px'}">
            <img :src="item.headPicUrl" :style="{height: height*0.098+'px',width:height*0.098+'px'}" >
          </div>
          <div class="mid-name">{{item.realName}}</div>
          <div class="mid-job">{{item.proTitle}}</div>
        </div>
      </div>


      <div class="wzb-active box" :style="{height:active,marginTop:active,marginBottom:active}">
        <div class="box box_f1">
          <div class="active-name box_f1 center" :style="{lineHeight:active}">支部活动</div>
          <div class="box_v box_f1" style="justify-content: space-between">
            <div class="center" style="font-weight: 600" :style="{height:a+'px',lineHeight: a+'px',fontSize: height>1000?'30px':'25px'}">{{huodongNumber}}个</div>
            <div :style="{height:b,lineHeight: b,fontSize: height>1000?'20px':'17px'}" class="center">活动数</div>
          </div>
          <div class="box_v box_f1" style="justify-content: space-between">
            <div style="font-weight: 600" :style="{height:a+'px',lineHeight: a+'px',fontSize: height>1000?'30px':'25px'}" class="center">{{qiandaoNumber}}人</div>
            <div :style="{height:b,lineHeight: b,fontSize: height>1000?'20px':'17px'}" class="center">签到数</div>
          </div>
        </div>
        <!--<div class="box box_f1">-->
          <!--<div class="active-name box_f1" :style="{lineHeight:active}">支部学习</div>-->
          <!--<div class="box_v box_f1" style="justify-content: space-between">-->
            <!--<div style="font-weight: 600" :style="{height:a+'px',lineHeight: a+'px',fontSize: height>1000?'30px':'25px'}">0个</div>-->
            <!--<div :style="{height:b,lineHeight: b,fontSize: height>1000?'20px':'17px'}">学习数</div>-->
          <!--</div>-->
          <!--<div class="box_v box_f1" style="justify-content: space-between">-->
            <!--<div style="font-weight: 600" :style="{height:a+'px',lineHeight: a+'px',fontSize: height>1000?'30px':'25px'}">0人</div>-->
            <!--<div :style="{height:b,lineHeight: b,fontSize: height>1000?'20px':'17px'}">学习人数</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>

      <div class="mid-title" :style="{marginBottom:height*0.035+'px'}">
        活动风采
      </div>
      <div style="display: flex;justify-content: center">
        <x-scroll v-if="index == nowIndex && activityPicList.length > 0" :contentArr="activityPicList" :height="picHeight" :lineNum="4" :width="width*0.098" :time="4000" :chixuTime="4">
          <div slot="scroll" slot-scope="props" :style="{marginRight:width*0.015+'px',width:width*0.083+'px'}">
            <img :src="props.todo" :style="{width: width*0.083+'px',height:picHeight+'px'}" >
          </div>
        </x-scroll>
      </div>

    </div>
  </div>
</template>

<script>
  import xScroll from '../../../components/xScroll'
  export default {
    components: {
      xScroll
    },
    data () {
      return {

      }
    },
    props:{
      index:Number,
      nowIndex:Number,
      height:Number,
      width:Number,
      manager:{
        type:Object,
        default:{}
      },
      leader:{
        type:Array,
        default:[]
      },
      huodongNumber:{
        type:Number,
        default:0
      },
      qiandaoNumber:{
        type:Number,
        default:0
      },
      activityPicList:{
        type:Array,
        default:function(){
          return []
        }
      }
    },
    computed: {
      active () {//60px
        return this.height*0.055+'px'
      },
      a () {//30px
        return this.height*0.029
      },
      b () {//20px
        return this.height*0.0196+'px'
      },
      picWidth () {
        if (this.height > 1000) {
          return this.height*0.16
        }else {
          return this.height*0.19
        }

      },
      picHeight () {
        if (this.height > 1000) {
          return this.height * 0.185
        }else {
          return this.height * 0.21
        }
      }
    }
  }
</script>

<style scoped>
  .wzbmid-wrapper{
    min-width: 570px;
    height: 100%;
    /*padding: 0 60px*/
  }
  .wzbmid{
    /*background: #ddd;*/
    height: 100%;
    position: relative;
  }
  .mid-title{
    text-align: center;
    font-size:28px;
    font-weight: 600;
    color: #4c4c4c
  }
  .mid-people{
    align-items: center;
    /*margin: 0 35px*/
  }
  /*.mid-people:first-child{*/
    /*margin-left:0*/
  /*}*/
  /*.mid-people:last-child{*/
    /*margin-right:0*/
  /*}*/
  .mid-pic img {
    border-radius: 50%;
  }
  .mid-name{
    font-size:25px;
    color:#444;
    text-align: center;
    font-weight: 600;
  }
  .mid-job{
    font-size:18px;
    color:#666;
    text-align: center;
  }
  .wzb-active{
    color:#ff4500;
  }
  .active-name{
    width: 170px;
    font-size: 24px;
    padding-left:25px
  }
  .pic-wrapper{
    border: 2px solid #fff;
    height:190px;
    width:173px;
    margin-left:20px
  }
  .aaa{
    height:190px;
    width:173px;
  }
  .center{
    text-align: center;
  }
</style>
